<template>
  <div class="antibot-verification">
    <!-- Honeypot - hidden from humans, bots fill it -->
    <div style="position: absolute; left: -9999px; top: -9999px;" aria-hidden="true">
      <input v-model="honeypot" type="text" name="website" tabindex="-1" autocomplete="off" />
    </div>

    <!-- Math CAPTCHA -->
    <v-text-field
      v-model="captchaAnswer"
      :label="captchaQuestion"
      variant="outlined"
      density="compact"
      type="number"
      prepend-inner-icon="mdi-shield-check"
      :error-messages="captchaError"
      class="mb-2"
      @update:model-value="validateCaptcha"
    />
  </div>
</template>

<script>
export default {
  name: 'AntibotVerification',
  emits: ['update:valid', 'antibot-data'],
  data() {
    return {
      honeypot: '',
      captchaAnswer: '',
      captchaError: '',
      num1: 0,
      num2: 0,
      operator: '+',
      expectedAnswer: 0,
      formLoadedAt: 0
    }
  },
  computed: {
    captchaQuestion() {
      return `Cat face ${this.num1} ${this.operator} ${this.num2}?`
    },
    isValid() {
      return this.honeypot === '' &&
        this.captchaAnswer !== '' &&
        parseInt(this.captchaAnswer) === this.expectedAnswer &&
        (Date.now() - this.formLoadedAt) >= 3000
    }
  },
  watch: {
    isValid(val) {
      this.$emit('update:valid', val)
    }
  },
  mounted() {
    this.formLoadedAt = Date.now()
    this.generateCaptcha()
  },
  methods: {
    generateCaptcha() {
      const ops = ['+', '-']
      this.operator = ops[Math.floor(Math.random() * ops.length)]
      if (this.operator === '+') {
        this.num1 = Math.floor(Math.random() * 20) + 1
        this.num2 = Math.floor(Math.random() * 20) + 1
        this.expectedAnswer = this.num1 + this.num2
      } else {
        this.num1 = Math.floor(Math.random() * 20) + 10
        this.num2 = Math.floor(Math.random() * (this.num1 - 1)) + 1
        this.expectedAnswer = this.num1 - this.num2
      }
    },
    validateCaptcha() {
      if (this.captchaAnswer === '') {
        this.captchaError = ''
        return
      }
      if (parseInt(this.captchaAnswer) !== this.expectedAnswer) {
        this.captchaError = 'Raspuns incorect'
      } else {
        this.captchaError = ''
      }
    },
    getAntibotData() {
      return {
        website: this.honeypot,
        elapsed_ms: Date.now() - this.formLoadedAt,
        captcha_valid: parseInt(this.captchaAnswer) === this.expectedAnswer
      }
    }
  }
}
</script>

<style scoped>
.antibot-verification {
  position: relative;
}
</style>
